import { render, staticRenderFns } from "./inputMessage.vue?vue&type=template&id=3c44710f&scoped=true"
import script from "./inputMessage.vue?vue&type=script&lang=js"
export * from "./inputMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c44710f",
  null
  
)

export default component.exports